<template>
  <Adult @enter-fn="onClickVerification" @exit-fn="$emit('on-close')" />
</template>

<script setup>
  import { computed, defineEmits, watch } from 'vue'
  import { setCookieVerifiedAdult } from '@/common/utils/adult'
  import { useRoute } from 'vue-router/composables'
  import { ADULT_LAYER_POPUP } from '@/common/resources/const'
  import { EventBus } from '@/common/utils/event-bus'
  import Adult from '@/components/adult/Adult'

  defineEmits(['on-close'])
  const route = useRoute()

  const routePath = computed(() => route?.fullPath ?? '')
  const isLayerPopupRoute = computed(() => {
    const routes = ['player', 'instantlist'] // 성인인증 풀페이지 팝업이 가능한 라우터 배열
    return (
      routes.filter((route) =>
        routePath.value.match(new RegExp(`/(${route})`, `gi`)),
      ).length > 0
    )
  })

  const onClickVerification = () => {
    setCookieVerifiedAdult()
    EventBus.$emit(ADULT_LAYER_POPUP, { isOpen: false })
  }

  watch(
    () => route.query,
    () => {
      if (!isLayerPopupRoute.value) {
        EventBus.$emit(ADULT_LAYER_POPUP, { isOpen: false })
      }
    },
  )
</script>
